import { observable, action, computed, makeObservable } from 'mobx';
import TaskStore from './TaskStore';

class Store {
  building_id = null;
  description = '';
  done = false;
  files = [];
  groupId = null;
  id = null;
  isLoading = false;
  project_id = null;
  status = null;
  title = 'needs_action';
  users = [];

  clearTask = () => {
    this.building_id = null;
    this.description = '';
    this.status = 'needs_action';
    this.groupId = null;
    this.done = false;
    this.files = [];
    this.id = null;
    this.isLoading = false;
    this.project_id = null;
    this.title = '';
    this.users = [];
  };

  loadTask = async taskId => {
    this.isLoading = true;
    const task = await TaskStore.loadTask(taskId);
    this.building_id = task.building_id;
    this.description = task.description;
    this.done = task.done;
    this.status = task.status;
    this.files = task.files;
    this.groupId = task.group_id;
    this.id = task.id;
    this.isLoading = false;
    this.project_id = task.project_id;
    this.status = task.status;
    this.title = task.title;
    this.users = task.users;
  };

  deleteTask = async taskId => {
    await TaskStore.deleteTask(taskId);
    this.clearTask();
  };

  change = (name, value) => {
    this[name] = value;
  };

  setFiles = files => {
    this.files = files;
  };

  setDescription = description => {
    this.description = description;
  };

  setGroup = groupId => {
    this.groupId = groupId;
  };

  constructor() {
    makeObservable(this, {
      building_id: observable,
      description: observable,
      done: observable,
      files: observable,
      groupId: observable,
      id: observable,
      isLoading: observable,
      project_id: observable,
      status: observable,
      title: observable,
      users: observable,
      clearTask: action,
      loadTask: action,
      deleteTask: action,
      change: action,
      setFiles: action,
      setDescription: action,
      setGroup: action,
      userIds: computed,
      fileIds: computed,
      setFileId: action,
      submit: action
    });
  }

  get userIds() {
    return this.users.map(u => u.id);
  }

  get fileIds() {
    return this.files.map(u => u.id);
  }

  setFileId = (fileTempId, fileId) => {
    const index = this.files.findIndex(file => file.id === fileTempId);
    if (index > -1) {
      this.files[index].id = fileId;
    }
  };

  submit = () => {
    const data = {
      description: this.description,
      status: this.status,
      title: this.title,
      users: this.users
    };

    if (this.id) return TaskStore.update(this.id, data);
    return TaskStore.create({
      ...data,
      group_id: this.groupId,
      building_id: this.building_id,
      project_id: this.project_id
    });
  };
}

const store = new Store();
export default store;
